import React from 'react';
import styled from 'styled-components/native';
import { ImageStyle } from 'react-native';
import { useAssets } from '@/hooks/use.assets';
import { AppImageView } from '@/components/base/app.image.view';
import { generateShadow } from '@/components/base/app.card.view';
import { theme } from '@/assets/theme';

interface Props {
  url: string;
  style?: ImageStyle;
  shadow?: boolean;
}
function BaseAppAvatar({ url, style, shadow = true }: Props) {
  const assets = useAssets();
  return <Image source={url} contentFit={'cover'} variant={'circle'} placeholder={assets.images.default_blank_image} style={[style, shadow ? shadowStyle : undefined]} />;
}

const shadowStyle = generateShadow({ shadowColor: theme.colors.blackLight, shadowOffsetX: 1, shadowOffsetY: 2, shadowOpacity: 0.3, blurRadius: 6 });

const Image = styled(AppImageView)`
  width: ${({ theme }) => theme.hp(8.5)}px;
  height: ${({ theme }) => theme.hp(8.5)}px;
  border-color: white;
  border-width: 1px;
`;

export const AppAvatar = React.memo(BaseAppAvatar);
